<template>
  <button @click="handleClick">
    {{ box.title }} <icon name="nextSmall" :alt="box.title" />
  </button>
</template>
<script setup lang="ts">
interface Props {
  box: any;
}

const props = defineProps({
  box: null
});

const paths = inject<Ref<string[]>>(Constant.PARAMETERS_PATHS);

const handleClick = () => {
  paths.value.push(props.box.name);
};
</script>
<style lang="scss" scoped>
button {
  @include font('n', 700);

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: var(--color_neutral_700);
  &:hover,
  &:focus {
    color: var(--color_secondary);
    input[type='checkbox'] {
      border: var(--stroke_thickness_l) solid var(--color_secondary);
      outline: 0;
      &::before {
        background-color: var(--color_neutral_900);
        box-shadow: inset 1rem 1rem var(--color_neutral_900);
      }
    }
  }
}
</style>
